import { render, staticRenderFns } from "./handle-edit.vue?vue&type=template&id=447d3592&scoped=true&"
import script from "./handle-edit.vue?vue&type=script&lang=js&"
export * from "./handle-edit.vue?vue&type=script&lang=js&"
import style0 from "./handle-edit.vue?vue&type=style&index=0&id=447d3592&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d3592",
  null
  
)

export default component.exports